module.exports = __webpack_public_path__ + "img/ico-wechat.601a6f5e.svg";